export default {
    defaultEnv: '',
    forcedEnv: '',
    baseUrl: '',
    authUrl: '',
    format: 'msgpack',
    token: '',
    tokenType: '',
    clientKey: '',
    nonces: [],
    userInfo: {},
    maintenance: {}
}
